import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';


const accountOut = [
  {
    'name': 'Estado de Cuenta',
    'path': paths.AccountState,
    'resource': resources.AccountList,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
];


const getAccountOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Reporte',
    'options': filterByPermissions(permissions, accountOut),
  }];

  return options.filter((item) => item.options.length);
};

export const getAccountOptions = (permissions) => {
  const options = [
    {
      'name': 'Consulta',
      'options': getAccountOutcomeOptions(permissions),
    }];
  
  return options.filter((item) => item.options.length);
};


export const accountOptions = [
  ...accountOut,
];
